import { useQuery } from "@tanstack/react-query";

import {
  getModules,
  type ModuleListSortColumn,
  type ModuleStatus,
  type SortOrder,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";

export const getModulesQueryKey = (
  offset?: number,
  limit?: number,
  searchQuery?: string,
  statusFilter?: ModuleStatus[],
  sortBy?: ModuleListSortColumn,
  sortOrder?: SortOrder,
) => [
  "MODULES_QUERY",
  offset,
  limit,
  searchQuery,
  statusFilter,
  sortBy,
  sortOrder,
];

interface UseModulesQueryParams {
  offset?: number;
  limit?: number;
  searchQuery?: string;
  statusFilter?: ModuleStatus[];
  sortBy?: ModuleListSortColumn;
  sortOrder?: SortOrder;
}

export function useModulesQuery(params?: UseModulesQueryParams) {
  const { offset, limit, searchQuery, statusFilter, sortBy, sortOrder } =
    params ?? {};

  return useQuery({
    queryKey: getModulesQueryKey(
      offset,
      limit,
      searchQuery,
      statusFilter,
      sortBy,
      sortOrder,
    ),
    queryFn: processResponse(() =>
      getModules(offset, limit, searchQuery, statusFilter, sortBy, sortOrder),
    ),
  });
}
